// extracted by mini-css-extract-plugin
export default {"wrapper":"Q7-z"};